import React from 'react';
import { ListProps } from 'react-admin';
import ServiceCataloguePage from './Catalogue/ServiceCataloguePage';
import { ServiceCatalogueConfig } from './Catalogue/types';

/**
 * The service owner's view of the catalogue: the services their team owns,
 * with everything it takes to administer one, plus a switch onto the services
 * they depend on.
 */
const config: ServiceCatalogueConfig = {
    resource: 'services',
    pov: 'serviceowner',
    dependantResource: 'dependant_services',
};

const ServiceList = (props: ListProps) => <ServiceCataloguePage config={config} listProps={props} />;

export default ServiceList;
